import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

import participants from "./participants.js"
import directMessages from "./messages/direct.js"
import roomMessages from "./messages/room.js"
import notice from "./notice.js"
import authStore from "./auth.js"
import event from "./event.js"
import hall from "./hall.js"
import corner from "./corner.js"
import room from "./room.js"
import loading from "./loading.js"
import stream from "./stream"
import sideMenu from "./side_menu"
import device from "./device.js"
import progress from "./progress"
import userMenu from "./user_menu"
import requestReload from "./request_reload"
import liveQuestionnaire from "./live_questionnaire"

Vue.use(Vuex)

export default router => {
  const auth = authStore(router)
  const ls = Vue.prototype.$sl

  return new Vuex.Store({
    modules: {
      participants,
      directMessages,
      roomMessages,
      notice,
      auth,
      event,
      hall,
      corner,
      room,
      loading,
      stream,
      sideMenu,
      device,
      progress,
      userMenu,
      requestReload,
      liveQuestionnaire
    },
    plugins: [
      createPersistedState({
        key: Vue.prototype.$config.app.name,
        paths: ["auth.userId", "auth.token"],
        storage: {
          getItem: key => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: key => ls.remove(key)
        }
      }),
      createPersistedState({
        key: Vue.prototype.$config.storage.settings,
        paths: ["auth.settings"],
        storage: {
          getItem: key => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: key => ls.remove(key)
        }
      }),
      createPersistedState({
        key: Vue.prototype.$config.storage.videoDeviceId,
        paths: ["device.videoDeviceId"],
        storage: {
          getItem: key => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: key => ls.remove(key)
        }
      }),
      createPersistedState({
        key: Vue.prototype.$config.storage.micDeviceId,
        paths: ["device.micDeviceId"],
        storage: {
          getItem: key => ls.get(key),
          setItem: (key, value) => ls.set(key, value),
          removeItem: key => ls.remove(key)
        }
      })
    ]
  })
}
